module.exports = __webpack_public_path__ + "img/title.5a9d45a3.gif";